import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colors.background};
    border-radius: ${theme.radius.default};
    box-shadow: ${theme.shadows.flat};
    padding: 2.4rem;
    margin: 2.4rem 0;
  `}
`;

export const Content = styled.div`
  max-width: 680px;
  display: flex;
  flex-wrap: wrap;
`;

export const Wrapper = styled.div`
  @media (max-width: 1010px) {
    width: 100% !important;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 20;

  @media (max-width: 1010px) {
    float: right;
    flex-direction: column;

    > button {
      margin: 0 0 1rem 0;
    }
  }
`;
